import React from "react";
import { Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

export default function FinalCTA({ onCta }) {
  return (
    <section className="relative px-5 py-24 sm:py-32 overflow-hidden">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <div className="relative rounded-[2rem] bg-slate-900 text-white px-7 sm:px-14 py-16 sm:py-20 text-center overflow-hidden">
            {/* brand glow */}
            <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full opacity-40 blur-3xl" style={{ background: "radial-gradient(circle at center, rgba(122,108,255,0.55), rgba(74,59,250,0.25) 45%, transparent 72%)" }} />
            <div className="pointer-events-none absolute inset-0 opacity-[0.15]" style={{ backgroundImage: "radial-gradient(#fff 0.5px, transparent 0.5px)", backgroundSize: "24px 24px", maskImage: "radial-gradient(ellipse 60% 60% at 50% 40%, black, transparent)" }} />

            <div className="relative">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-[12px] font-medium bg-white/10 text-white/80 mb-6">
                <span className="w-2 h-2 rounded-full bg-[#7A6CFF]" /> Comece em menos de 1 minuto
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] max-w-2xl mx-auto">
                Pare de perder tempo fazendo orçamentos. Faça o próximo em segundos.
              </h2>
              <p className="mt-5 text-slate-300 text-base sm:text-lg max-w-xl mx-auto">
                Seu primeiro orçamento é grátis. Sem cartão, sem complicação.
              </p>
              <button onClick={onCta} data-testid="final-cta-btn" className="mt-9 inline-flex items-center justify-center gap-2 h-13 px-8 py-4 rounded-full bg-white text-slate-900 text-[15px] font-semibold hover:bg-slate-100 transition-all hover:scale-[1.03] active:scale-95 shadow-xl">
                <Sparkles size={18} /> Começar grátis
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
